module.exports = __webpack_public_path__ + "img/write.be5030ca.webp";